module.exports = __webpack_public_path__ + "images/bcfceeee05b77a2ede311714754c5dc9-VL_RGB_Primary_FullColor_53c4e7f7-756c-4648-8a10-8153efb3e0f4.png";